import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import AddIcon from '@material-ui/icons/Add';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../styles/colors';
import ButtonContent from '../ButtonContent';
import { faTrash, faPlus } from '@fortawesome/free-solid-svg-icons'
import { ConfirmJsMessage } from '../../helpers.js';
import StartCalendar from "./StartCalendar";
import TimePick from "./TimePicker";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { AlertJsMessage } from './../../helpers.js';
import moment from 'moment';



const ScheduleCall = props => {
	const {
		clientEmail,
        fetchScheduleCall,
        saveScheduleCall
	} = props;

	const [date, setDate] = useState();
    const [passDate, setPassDate] = useState(null);

    const [isFetchRes, setFetchRes] = useState(false);
  
	useEffect(() => {
	   fetchData()
	}, [clientEmail])

    const fetchData = () => {
        fetchScheduleCall({
            clientEmail
        }).then((res) => {
            const data = res;
            let list = Object.values(data);
            if (list.length > 0) {
                setDate(new Date(list[0]['scheduleDate']))
            } else {
                setDate(new Date())
            }
        })
    }

    const changeTime = (data) => {
        if (data) {
            let date = new Date(data);
            setPassDate(date);
        }
    }

    const submitData = () => {
        if(date === '') {
            AlertJsMessage('Date is required.');
            return;
        }
        saveScheduleCall({
            scheduleDate: passDate,
            clientEmail: clientEmail
        })
        .then((res) => {
            fetchData();
        })
    }

    
    return (
        <Fragment>
            <div
					style={{
						marginTop: 25,
					    width: '600px'
					}}
				>
                   

                   <div style={{marginTop: '5px'}}>
                   <div style={{
                                display: 'flow-root',
                                padding: 20,
                                paddingLeft: 0,
                                width: '100%',
                                height: '90px'
                                }}>
                            <div style={{
                                display: 'initial',
                                float: 'left',
                                width: '400px'
                            }}>
                            <p>Select Deadline Time</p>
                              <TimePick date={date} changeTime={changeTime} />
                            </div>
                        </div>
                        <div style={{ marginTop: '10px'}}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => submitData()}
                                disabled={passDate === null}
                            >
                                <ButtonContent
                                    text="Save"
                                    icon="chevron-right" />
                            </Button>
                        </div>
                    </div>
                </div>
        </Fragment>
    );
};

export default ScheduleCall;



// WEBPACK FOOTER //
// ./src/components/assignments/ScheduleCall.js